import types from './types';

const INITIAL_STATE = {
    isFetchingExpired: false,

    result: [],
};

const authExpiredReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_EXPIRED_AUTH_REQUEST:
        return {
            ...state,
            result: [],
            isFetchingExpired: true,
        };

    case types.GET_EXPIRED_AUTH_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetchingExpired: false,
        };

    case types.GET_EXPIRED_AUTH_FAILURE:
        return {
            ...state,
            result: [],
            isFetchingExpired: false,
        };

    default:
      return state;
  }
};

export default authExpiredReducer;
